import { __decorate, __metadata } from "tslib";
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { ArrayNotEmpty, IsArray, IsDate, IsNotEmpty, IsOptional, IsString, ValidateNested } from 'class-validator';
import { PromotionExposeGroup } from '../interface';
import { ReadPromotionReferenceDto } from './ReadPromotionReferenceDto';
export class ReadDynamicPromoCodeDto {
}
__decorate([
    ApiProperty({ type: () => String, format: 'uuid', description: 'uuid v4' }),
    Expose({ groups: [PromotionExposeGroup.READ] }),
    __metadata("design:type", String)
], ReadDynamicPromoCodeDto.prototype, "uuid", void 0);
__decorate([
    ApiProperty({ type: () => String, description: 'Merchant ID' }),
    Expose({ groups: [PromotionExposeGroup.READ] }),
    __metadata("design:type", String)
], ReadDynamicPromoCodeDto.prototype, "merchantId", void 0);
__decorate([
    ApiProperty({ type: () => ReadPromotionReferenceDto, isArray: true, description: 'Promotion reference' }),
    Type(() => ReadPromotionReferenceDto),
    Expose({
        groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE],
    }),
    IsArray({ always: true }),
    ArrayNotEmpty({ always: true }),
    ValidateNested({ always: true, each: true }),
    __metadata("design:type", Array)
], ReadDynamicPromoCodeDto.prototype, "promotionReferences", void 0);
__decorate([
    ApiProperty({ type: () => String, description: 'Promo code' }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadDynamicPromoCodeDto.prototype, "promoCode", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Tags' }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE] }),
    IsOptional({ always: true }),
    IsArray({ always: true }),
    IsNotEmpty({ always: true, each: true }),
    IsString({ always: true, each: true }),
    __metadata("design:type", Array)
], ReadDynamicPromoCodeDto.prototype, "tags", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Date, description: 'Expiration time' }),
    Type(() => Date),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    IsDate({ always: true }),
    __metadata("design:type", Object)
], ReadDynamicPromoCodeDto.prototype, "expiresAt", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'User who used the promocode' }),
    Expose({ groups: [PromotionExposeGroup.READ] }),
    __metadata("design:type", String)
], ReadDynamicPromoCodeDto.prototype, "userId", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Date, description: 'Time the promocode has been used' }),
    Type(() => Date),
    Expose({ groups: [PromotionExposeGroup.READ] }),
    __metadata("design:type", Date)
], ReadDynamicPromoCodeDto.prototype, "usedAt", void 0);
__decorate([
    ApiProperty({ type: () => Date, description: 'Creation date' }),
    Type(() => Date),
    Expose({ groups: [PromotionExposeGroup.READ] }),
    __metadata("design:type", Date)
], ReadDynamicPromoCodeDto.prototype, "createdAt", void 0);
__decorate([
    ApiProperty({ type: () => Date, description: 'Update date' }),
    Type(() => Date),
    Expose({ groups: [PromotionExposeGroup.READ] }),
    __metadata("design:type", Date)
], ReadDynamicPromoCodeDto.prototype, "updatedAt", void 0);
//# sourceMappingURL=ReadDynamicPromoCodeDto.js.map